import { defineStore } from '@/modules/pinia-hot'
import {
  profileDetailResource,
} from '@/services/profile.service'
import { User as BaseUser } from './base/user'
/* eslint-disable */
const id = 'user'

export const useUserStore = defineStore(id, {
  state: () => ({
    profile: '',
    user: new BaseUser({}, false),
  }),
  getters: {
    getUserInfo: (state) => state.user,
  },
  actions: {
    async getUserData() {
      try {
        const { data: { item } } = (await profileDetailResource.execute({}))
        this.profile = item
        this.user = new BaseUser(item)
        console.log("🚀 ~ getUserData ~ this.user:", this.user)
      } catch (e) {
        
      }
    },
  },
})